<template>

    <form method="post" ref="formEditPost" enctype="multipart/form-data">
        <input name="_token" type="hidden" :value="csrfToken">
        <div class="row row-cards">
            <div class="col-12 col-md-8 col-lg-8">
                <div class="row row-cards"> 

                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                Title
                            </div>
                            <div class="card-body">
                                <div class="form-group mb-3">
                                    <input type="text" name="title" v-model="post.title" required="" class="form-control" id="title" value="" placeholder="Enter Title">
                                </div>
                                <div v-if="!data.isCommunity" class="form-group mb-3">
                                    <label class="form-label required" for="type">Post Type</label>                  
                                    <select class="form-select" name="type" v-model="type_name">
                                        <option value="">-- Select Post Type --</option>
                                        <option v-for="(type, index) in types" :key="index" :value="type.id">{{ type.desc }}</option> 
                                    </select>  
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                Attachments
                            </div>
                            <div class="card-body">
                                <div class="form-group mb-3">
                                    <div v-for="(attachment, index) in attachments" :key="attachment.id" class="row" style="margin-bottom: 10px;">
                                        <div class="col-4">
                                            <input v-model="attachment.title" :name="'attach_title['+index+']'" type="text" class="form-control" placeholder="Enter Title">
                                            <input type="hidden" :name="'attach_hashslug['+index+']'" :value="attachment.hashslug">
                                        </div>
                                        <div class="col-4">
                                            <input type="file" :name="'attach_filename['+index+']'" class="form-control" v-on:change="uploadAttachment(index)">                                            
                                        </div>
                                        <div class="col-4">
                                            <div class="input-group">
                                                <input type="text" class="form-control" v-model="attachment.label" :name="'attach_label['+index+']'" readonly>
                                                <input type="hidden" :name="'attach_url['+index+']'" v-model="attachment.filename">
                                                <input type="hidden" :name="'attach_size['+index+']'" v-model="attachment.size">
                                                <input type="hidden" :name="'attach_extension['+index+']'" v-model="attachment.extension">                                                
                                                <button v-if="attachment.download" type="button" class="btn btn-icon" title="View" v-on:click="downloadAttachment(attachment.full_url)">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-download" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                       <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                       <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
                                                       <polyline points="7 11 12 16 17 11"></polyline>
                                                       <line x1="12" y1="4" x2="12" y2="16"></line>
                                                    </svg>
                                                </button>
                                                <button type="button" class="btn btn-icon" title="Remove Row" v-on:click="removeRow(index, attachment.hashslug)" v-if="attachments.length > 1">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><circle cx="12" cy="12" r="9" /><line x1="9" y1="12" x2="15" y2="12" /></svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>                                
                                </div>
                                <div class="form-group mb-3">
                                    <button type="button" class="btn btn-primary" v-on:click="addRow">
                                        Add File
                                    </button>
                                </div>
                                <small>
                                    Note: <br>
                                    1. File must use the following format: jpg/png/mp4/pdf<br>
                                    2. Size must not exceed 1GB.<br>
                                    3. Smaller is better.<br>
                                    4. Make sure file is not corrupted.
                                </small>                              
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                Description
                            </div>
                            <div class="card-body">
                                <div class="form-group mb-3">
                                    <textarea id="editor" v-model="post.long_desc" name="long_desc" style="border: 0px;"></textarea>  
                                </div>
                            </div>
                            <div class="card-footer">
                                <button type="button" class="btn btn-blue" v-on:click="saveEditPost" :disabled="disableAfterSubmit">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2" /><circle cx="12" cy="14" r="2" /><polyline points="14 4 14 8 8 8 8 4" /></svg>
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-4 col-lg-4">
                <div class="row row-cards">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="form-group mb-3">
                                    <label class="form-label required" for="category">Category</label>
                                    <select class="form-select" required="" name="category_id" v-model="category" @change="getSubCategories();">
                                        <option value="">-- Select Category --</option>
                                        <option v-for="(category, index) in categories" :key="index" :value="category.id">{{ category.name }}</option>   
                                    </select>   
                                </div>
                                <div class="form-group mb-3">
                                    <label class="form-label" for="category">Sub Category</label>
                                    <select class="form-select" name="sub_category_id" v-model="sub_category" @change="getTopics();">
                                        <option value="">-- Select Category --</option>
                                        <option v-for="(sub_category, index) in sub_categories" :key="index" :value="sub_category.id">{{ sub_category.name }}</option> 
                                    </select>   
                                </div>
                                <div class="form-group mb-3">
                                    <label class="form-label">Topic</label>
                                    <select class="form-select" name="topic_id" v-model="topic" @change="getSubTopics();">
                                        <option value="">-- Select Topic --</option>
                                        <option v-for="(topic, index) in topics" :key="index" :value="topic.id">{{ topic.name }}</option>
                                    </select>   
                                </div>
                                <div class="form-group mb-3">
                                    <label class="form-label">Sub Topic</label>
                                    <select class="form-select" name="sub_topic_id" v-model="sub_topic">
                                        <option value="">-- Select Sub Topic --</option>
                                        <option v-for="(sub_topic, index) in sub_topics" :key="index" :value="sub_topic.id">{{ sub_topic.name }}</option>
                                    </select>   
                                </div>  
                                <div class="form-group mb-3">
                                    <label class="form-label required" for="tag">Tag</label>
                                    <input name="tag" id="tag" required="" :value="this.tags" type="text" class="form-control" placeholder="Enter Tag">
                                    <small class="form-hint">Put comma to separate the tag name. Used to display related topics.</small> 
                                </div>
                                <div class="form-group mb-3">
                                    <label class="form-label" for="meta">Meta</label>                  
                                    <textarea class="form-control" v-model="post.meta" id="meta" name="meta" rows="5" placeholder="Enter Meta Description"></textarea>
                                    <small>Used to search additional keywords.</small>
                                </div>
                                <div class="form-group mb-3">
                                    <label class="form-label" for="reference">Cited</label>                  
                                    <textarea class="form-control" id="reference" v-model="post.reference" name="reference" rows="5" placeholder="Enter Reference"></textarea>
                                </div>
                                <div class="form-group mb-3" v-if="!data.isCommunity">
                                    <label class="form-label" for="reference">Priority</label>                  
                                    <select class="form-select" name="priority" v-model="post.priority">
                                        <option value="">-- Select Priority --</option>
                                        <option v-for="(priority, index) in priorities" :key="index" :value="priority.id">{{ priority.name }}</option> 
                                    </select>   
                                </div>
                                <div class="form-group mb-3" v-if="!data.isCommunity">
                                    <label class="form-label">Active</label>
                                    <select class="form-select" name="is_active" v-model="post.is_active">
                                        <option v-for="(a, index) in is_active" :key="index" :value="a.id">{{ a.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <input type="hidden" v-model="attach_del" name="attach_del">        
    </form>
</template>

<script>
    export default {
        props: ['data'],
        data() {
            return {
                post: [],
                csrfToken: "",
                type_name: "",
                selected_type: "",
                tags: "",
                haveAttachment: false,
                post_images: [],
                types: [],
                category: "",
                sub_category: "",                
                categories: [],
                sub_categories: [],
                department_id: "",
                attachments: [{
                    id: this.counterAttach, title: "", filename: "", progress: false, label: "", size: "", extension: "", download: false, full_url: "",                   
                }],
                is_active: [
                    {id: 1, name: 'Active'},
                    {id: 0, name: 'Inactive'},
                ],
                priorities: [],
                topics: [],
                sub_topics: [],
                topic: "",
                sub_topic: "",
                counterAttach: 0,
                attach_del: [],
                disableAfterSubmit: false,                
            };
        },        
        mounted() {
            this.csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;
            this.getPostByHashslug();
            this.getCategories(this.data.isCommunity);
            this.getPriorityLists();
            this.getTypes();
        },
        methods: {
            getPostByHashslug() {
                axios.get('/api/ajax/mod/posts/hashslug/' + this.data.hashslug)
                    .then(res => {
                        this.post = res.data;
                        this.type_name = res.data.type;
                        this.selected_type = res.data.publish_as;
                        if (res.data.attachments.length) {
                            this.attachments = res.data.attachments;
                        }                        
                        this.tags = res.data.tags
                        let tag = [];
                        $.each(res.data.tags, function(key, value) {
                            tag.push(value.name);
                        });
                        this.tags = tag.join(",");
                        this.category = res.data.category_id;
                        this.sub_category = res.data.sub_category_id;
                        this.topic = res.data.topic_id;
                        this.sub_topic = res.data.sub_topic_id;
                        this.getSubCategories();
                        this.getTopics();
                        this.getSubTopics();
                    });
            },
            getTypes() {
                axios.get('/api/ajax/mod/posts/types').then(res => {
                    this.types = res.data.data;
                });
            }, 
            getCategories: function(group) {
                axios.get('/api/ajax/mod/posts/categories/' + group)
                .then(function (resp) {
                    this.categories = resp.data;
                }.bind(this));
            }, 
            getSubCategories: function() {
                axios.get('/api/ajax/mod/posts/sub_categories',{
                    params: {
                        category_id: this.category
                    }
                }).then(function(resp){
                    this.sub_categories = resp.data;
                    this.topics = [];
                    this.sub_topics = [];
                }.bind(this));
            },
            getTopics: function() {
                axios.get('/api/ajax/mod/posts/topics',{
                    params: {
                        sub_category_id: this.sub_category
                    }
                }).then(function(resp){
                    this.topics = resp.data;                                                          
                }.bind(this));
            },
            getSubTopics: function() {
                axios.get('/api/ajax/mod/posts/sub_topics',{
                    params: {
                        topic_id: this.topic
                    }
                }).then(function(resp){
                    this.sub_topics = resp.data;                
                }.bind(this));
            },            
            addRow() {
                this.counterAttach += 1;                
                this.attachments.push({
                    id: this.counterAttach, title: "", filename: "", progress: false, label: "", size: "", extension: "", download: false, full_url: "",                   
                });
            },
            removeRow(index, hashslug) {
                if (hashslug) {
                    this.attach_del.push(hashslug);
                }
                this.attachments.splice(index, 1);
            },
            openFilename(url) {
                window.open(url);
            },
            getPriorityLists() {
                axios.get('/api/ajax/mod/posts/priorities').then(res => {
                    this.priorities = res.data.data;
                });
            },
            uploadAttachment(index) {
                const file = event.target.files[0];
                if (file) {
                    this.attachments[index].label = 'Please Wait...';
                    this.attachments[index].progress = true;
                    const form = new FormData();
                    form.append('file', file);
                    axios.post( '/api/ajax/mod/posts/upload-attachment',
                    form,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        onUploadProgress: function(progressEvent) {
                            this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                        }.bind(this)
                    })
                    .then(res => {
                        if (res.data.data.is_format) {
                            this.attachments[index].label = res.data.data.label;
                            this.attachments[index].filename = res.data.data.filename;
                            this.attachments[index].full_url = res.data.data.full_url;
                            this.attachments[index].size = res.data.data.size;
                            this.attachments[index].extension = res.data.data.extension;
                            this.attachments[index].progress = false;
                            this.attachments[index].download = true;
                        }
                        else {
                            this.attachments[index].label = res.data.message;
                            this.attachments[index].filename = "";
                            this.attachments[index].full_url = "";
                            this.attachments[index].size = "";
                            this.attachments[index].extension = "";
                            this.attachments[index].progress = false;                      
                            this.attachments[index].download = false;                      
                        }
                    })
                    .catch(err => {  
                        console.log(err);                  
                    });                     
                }   
            },
            downloadAttachment(url) {
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('target', '_blank');
                document.body.appendChild(link);
                link.click();
            },
            saveEditPost() {
                this.disableAfterSubmit = true;
                this.$refs.formEditPost.submit();
            },                      
        },
                       
    }
</script>
